export default __webpack_public_path__ + "static/media/info-icon.2ed87493.svg";